import React, { Component } from 'react';
import PathContext from "../../context/path";
import Cards from '../../components/Cards';
import ProgressFeel from '../../components/ProgressFeel';
import HeightSlider from '../../components/HeightSlider';
import Footer from '../../components/Footer';
import FooterCover from '../../components/FooterCover';
import Socials from '../../components/Socials';
// import ScrollTop from '../../components/ScrollTop';
import ScrollDown from '../../components/ScrollDown';
import styles from './Feel.module.sass';
class Feel extends Component {
	state = {}
	static contextType = PathContext;
	path = this.context;
	
	refWrap = React.createRef();
	componentDidMount() {

		window.scrollTo(0, 0);
		
		this.setHeight = this.setHeight.bind(this);
		this.setHeight();
		window.addEventListener('resize', this.setHeight);

	}
	componentWillUnmount() {
		window.removeEventListener('resize', this.setHeight, false);
	}
	setHeight() {
		let vh = window.innerHeight * 0.01;
		this.refWrap.current.style.setProperty('--vh', `${vh}px`);
	}

	render() {
		return <div ref={this.refWrap} className={styles.wrap} >

			{/* BG */}
			<div className={styles.bg1}>
				<picture>
					<source media="(min-width: 768px)" srcSet={`${this.path}/img/feel-bg-desktop.png`} />
					<img src={`${this.path}/img/feel-bg.png`} alt="" />
				</picture>
			</div>
			<div className={styles.bg2}>
				<picture>
					<source media="(min-width: 768px)" srcSet={`${this.path}/img/feel-bg2-desktop.png`} />
					<img src={`${this.path}/img/feel-bg2.png`} alt="" />
				</picture>
			</div>
			{/* cover */}
			<div className={styles.cover}>
				<div className="container">
					<h1 className={styles.title} >
					I feel all right. But could I be ill?
					</h1>
					<div className={styles.text} data-aos="fade-up">
					How the virus develops: symptoms and possible signs
					</div>
					<div className={styles.img}>
						{/* <img src={`${this.path}/img/feel-cover.png`} alt="" /> */}
						<img src={`${this.path}/img/gifs/icon2.gif`} loading='lazy' alt="" />
					</div>
					<div className={styles.socials}>
					<Socials suffix={'blue'}/>
					</div>
				</div>
				<ScrollDown />
			</div>
			<div className={styles.progress}>
				<HeightSlider height={10}>
					<ProgressFeel />
				</HeightSlider>
			</div>
			<div className="container">
				<div className={styles.text_2} data-aos="fade-up">
				Luckily, this is happening less and less frequently. Thanks to the use of antiretroviral therapy at an early stage, HIV doesn’t progress and AIDS doesn’t develop.
				</div>
			</div>
			<div className={styles.faq}>
				<div className="container">
					<div  data-aos="fade-up">
					<h2 className={styles.faq_title}>An HIV-positive person differs from you in no perceptible form</h2>
					<div className={styles.faq_text}>
						<p>People who are HIV-positive cannot be identified by any external signs.</p>
						<p>
							<span>You can’t diagnose an HIV infection by monitoring their symptoms either, particularly at an early stage.</span>
							<span>You can, however, take a test in order to be certain and to remove any concerns or doubts.</span>
						</p>
					</div>
					</div>
					<div className={styles.footer_cover}>
						<FooterCover />
					</div>
					<div className={styles.cards}>

						<Cards />
					</div>

				</div>
			</div>
			{/* <ScrollTop color={'blue'}/> */}
			<div className={styles.footer}>
				<Footer />
			</div>
		</div>;
	}
}

export default Feel;
